/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface RunExperimentResponse
 */
export interface RunExperimentResponse {
  /**
   *
   * @type {string}
   * @memberof RunExperimentResponse
   */
  message: string;
}

/**
 * Check if a given object implements the RunExperimentResponse interface.
 */
export function instanceOfRunExperimentResponse(
  value: object,
): value is RunExperimentResponse {
  if (!("message" in value) || value["message"] === undefined) return false;
  return true;
}

export function RunExperimentResponseFromJSON(
  json: any,
): RunExperimentResponse {
  return RunExperimentResponseFromJSONTyped(json, false);
}

export function RunExperimentResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): RunExperimentResponse {
  if (json == null) {
    return json;
  }
  return {
    message: json["message"],
  };
}

export function RunExperimentResponseToJSON(json: any): RunExperimentResponse {
  return RunExperimentResponseToJSONTyped(json, false);
}

export function RunExperimentResponseToJSONTyped(
  value?: RunExperimentResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    message: value["message"],
  };
}
